import jQuery from "jquery";

export default class FbShare {
  constructor(element) {
    // this loads the Facebook API
    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    window.fbAsyncInit = function () {
      let appId = "1935135856499288";
      FB.init({
        appId: appId,
        xfbml: true,
        version: "v2.9",
      });
    };

    // FB Share with custom OG data.
    (function ($) {
      $(".fb_share_btn").on("click", function (event) {
        let ogEl = this.parentNode.parentNode.parentNode;
        console.log(ogEl);

        event.preventDefault();
        event.stopImmediatePropagation();

        // Dynamically set the FB share data
        let ogUrl = window.location.href;
        let ogTitle = ogEl.getAttribute("data-title")
          ? ogEl.getAttribute("data-title")
          : "";
        let ogDescription = ogEl.getAttribute("data-description")
          ? ogEl.getAttribute("data-description")
          : "";
        let ogImage = ogEl.getAttribute("data-img")
          ? ogEl.getAttribute("data-img")
          : window.location.href;

        // Open FB share popup
        FB.ui(
          {
            method: "share_open_graph",
            action_type: "og.shares",
            action_properties: JSON.stringify({
              object: {
                "og:url": ogUrl,
                "og:title": ogTitle,
                "og:description": ogDescription,
                "og:image": ogImage,
              },
            }),
          },
          function (response) {
            // Action after response
          },
        );
      });
    })(jQuery);
  }
}
